import DialogReserveeForm from "./DialogReserveeForm";
import model              from "./model";

export default {
    name     : 'dialog_reservee_form',
    component: DialogReserveeForm,
    dialog   : {
        'max-width': "800px",
        'persistent': true
    },
    on       : {
        save(store, model) {
            store.commit('reservee_save', model);
        }
    },
    model
}
